const ballotDisplayOrder = [
  'bestPicture',
  'thankYou',
  'bestDirector',
  'bestActress',
  'bestActor',
  'bestSupportingActress',
  'bestSupportingActor',
  'bestOriginalScreenplay',
  'bestAdaptedScreenplay',
  'bestCasting',
  'bestMakeupAndHair',
  'bestCostumeDesign',
  'bestCinematography',
  'bestOriginalSong',
  'bestOriginalScore',
  'bestDocumentaryFeature',
  'bestAnimatedFeature',
  'bestInternationalFilm',
  'bestSound',
  'bestProductionDesign',
  'bestVisualEffects',
  'bestFilmEditing',
  'bestAnimatedShort',
  'bestLiveActionShort',
  'bestDocumentaryShort',
] as const;

export default ballotDisplayOrder;
